import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-6 px-10" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_4 = { class: "bg-white p-6 rounded-2xl mt-6" }
const _hoisted_5 = { class: "border p-6 rounded-2xl" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-5\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_4301_3301)\"><path d=\"M15.5919 6.25909L14.4254 6.02581C14.297 5.60041 14.1269 5.18966 13.9174 4.79903L14.5772 3.80938C14.7012 3.62344 14.6767 3.37587 14.5186 3.21791L12.7509 1.45012C12.5929 1.29212 12.3453 1.26762 12.1594 1.39153L11.1697 2.05131C10.7791 1.84181 10.3683 1.67175 9.94291 1.54338L9.70963 0.376812C9.66584 0.157719 9.47344 0 9.25 0H6.75C6.52656 0 6.33416 0.157719 6.29034 0.376812L6.05706 1.54338C5.63163 1.67175 5.22087 1.84184 4.83028 2.05131L3.84056 1.39153C3.65469 1.26762 3.40709 1.29212 3.24909 1.45012L1.48134 3.21791C1.32331 3.37591 1.29881 3.62347 1.42278 3.80938L2.08256 4.79903C1.87303 5.18966 1.70297 5.60041 1.57459 6.02581L0.408062 6.25909C0.188969 6.30291 0.03125 6.49531 0.03125 6.71875V9.21875C0.03125 9.44219 0.188969 9.63459 0.408094 9.67838L1.57463 9.91169C1.70297 10.3371 1.87306 10.7478 2.08259 11.1384L1.42281 12.1281C1.29884 12.314 1.32337 12.5616 1.48137 12.7196L3.24913 14.4873C3.40716 14.6454 3.65469 14.6699 3.84059 14.5459L4.81003 13.8997V10.957C4.07591 10.1756 3.625 9.12578 3.625 7.96875C3.625 5.5525 5.58375 3.59375 8 3.59375C10.4163 3.59375 12.375 5.5525 12.375 7.96875C12.375 9.12578 11.9241 10.1756 11.19 10.957V13.8997L12.1594 14.5459C12.2387 14.5988 12.3292 14.6247 12.4192 14.6247C12.5402 14.6247 12.6603 14.578 12.7508 14.4874L14.5186 12.7196C14.6766 12.5616 14.7011 12.3141 14.5772 12.1282L13.9174 11.1385C14.1269 10.7478 14.297 10.3371 14.4253 9.91172L15.5919 9.67841C15.811 9.63459 15.9688 9.44219 15.9688 9.21875V6.71875C15.9688 6.49531 15.811 6.30291 15.5919 6.25909Z\" fill=\"#3B82F6\"></path><path d=\"M9.48497 5.39989C9.24906 5.26323 8.94975 5.40823 8.91078 5.67804L8.625 7.65579H7.375L7.08925 5.67804C7.05025 5.40823 6.75097 5.26323 6.51506 5.39989C5.59978 5.93004 5.03125 6.91423 5.03125 7.96829C5.03125 9.11054 5.67094 10.1324 6.70066 10.6349L6.75 10.659V15.5308C6.75 15.7897 6.95987 15.9995 7.21875 15.9995H8.78125C9.04012 15.9995 9.25 15.7897 9.25 15.5308V10.659L9.29934 10.6349C10.3291 10.1324 10.9688 9.11054 10.9688 7.96829C10.9688 6.91423 10.4002 5.93004 9.48497 5.39989Z\" fill=\"#3B82F6\"></path></g><defs><clipPath id=\"clip0_4301_3301\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg><div class=\"text-sm font-semibold uppercase\">Регион и период</div></div>", 1)
const _hoisted_8 = { class: "flex items-center gap-4" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_11 = { class: "mt-6 grid grid-cols-2 gap-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_time_slot_form = _resolveComponent("time-slot-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Добавить тайм-слот" }),
      _createVNode(_component_router_link, { to: "/time-slots/list" }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "small second text" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Назад ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_the_select, {
              class: "w-72",
              placeholder: "Регион",
              value: _ctx.state.dispatcherSectorId,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.dispatcherSectorId) = $event)),
              disabled: _ctx.state.is_loading,
              loading: _ctx.data_state.dispatcher_sectors.is_loading,
              failed: _ctx.data_state.dispatcher_sectors.is_failed,
              options: _ctx.data_state.dispatcher_sectors.list,
              "is-invalid": _ctx.state_form$.dispatcherSectorId.$error,
              "validation-errors": _ctx.state_form$.dispatcherSectorId.$errors,
              onRefresh: _ctx.loadDispatcherSectors,
              onChange: _ctx.onDispatcherSectorChanged
            }, null, 8, ["value", "disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "onRefresh", "onChange"]),
            _createVNode(_component_the_select, {
              class: "w-72",
              placeholder: "Период",
              value: _ctx.state.periodGroupId,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.periodGroupId) = $event)),
              disabled: _ctx.state.is_loading,
              loading: _ctx.data_state.periods.is_loading,
              failed: _ctx.data_state.periods.is_failed,
              options: _ctx.data_state.periods.list,
              "is-invalid": _ctx.state_form$.periodGroupId.$error,
              "validation-errors": _ctx.state_form$.periodGroupId.$errors,
              onRefresh: _ctx.loadPeriods
            }, null, 8, ["value", "disabled", "loading", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
            _createVNode(_component_the_select, {
              class: "w-72",
              placeholder: "Тип",
              value: _ctx.state.typeId,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.typeId) = $event)),
              disabled: _ctx.state.is_loading,
              options: [{ id: 1, name: 'Забор' }, { id: 2, name: 'Доставка' }],
              searchable: false,
              "can-deselect": false
            }, null, 8, ["value", "disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_time_slot_form, {
          "is-main": "",
          "is-active": _ctx.state.mainTimeSlot.isActive,
          "time-from": _ctx.state.mainTimeSlot.timeFrom,
          "time-to": _ctx.state.mainTimeSlot.timeTo,
          capacities: _ctx.state.mainTimeSlot.capacities,
          "sectors-loading": _ctx.data_state.timeSlotZones.is_loading,
          "sectors-failed": _ctx.data_state.timeSlotZones.is_failed,
          sectors: _ctx.data_state.timeSlotZones.list,
          "sector-ids": _ctx.state.mainTimeSlot.zoneIds,
          "main-time-range": [],
          "reserved-time-range": [],
          onReloadSectors: _ctx.loadTimeSlotZones,
          onTimeFrom: _ctx.onMainTimeFrom,
          onTimeTo: _ctx.onMainTimeTo,
          onChangeTimeSlot: _ctx.onMainTimeSlotChanged,
          onUpdateCapacity: _ctx.onMainCapacity,
          onSelectSector: _ctx.onMainSelectTimeSlotZone,
          onUnselectSector: _ctx.onMainUnselectTimeSlotZone,
          onToggleActive: _ctx.onMainToggleActive
        }, null, 8, ["is-active", "time-from", "time-to", "capacities", "sectors-loading", "sectors-failed", "sectors", "sector-ids", "onReloadSectors", "onTimeFrom", "onTimeTo", "onChangeTimeSlot", "onUpdateCapacity", "onSelectSector", "onUnselectSector", "onToggleActive"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.childTimeSlots, (childTimeSlot, i) => {
          return (_openBlock(), _createBlock(_component_time_slot_form, {
            key: `childTimeSlot-${i}`,
            "is-main": false,
            index: i,
            "is-active": childTimeSlot.isActive,
            "time-from": childTimeSlot.timeFrom,
            "time-to": childTimeSlot.timeTo,
            capacities: childTimeSlot.capacities,
            "sectors-loading": _ctx.data_state.timeSlotZones.is_loading,
            "sectors-failed": _ctx.data_state.timeSlotZones.is_failed,
            sectors: _ctx.data_state.timeSlotZones.list.filter((s) => _ctx.state.mainTimeSlot.zoneIds.includes(s.id)),
            "sector-ids": childTimeSlot.zoneIds,
            "resource-limits": childTimeSlot.limits,
            "main-time-range": [_ctx.state.mainTimeSlot.timeFrom, _ctx.state.mainTimeSlot.timeTo],
            "reserved-time-range": _ctx.getReservedTimeRangesForChildTimeSlot(i),
            onTimeFrom: (timeFrom) => _ctx.onChildTimeFrom(i, timeFrom),
            onTimeTo: (timeTo) => _ctx.onChildTimeTo(i, timeTo),
            onUpdateCapacity: (capacity) => _ctx.onChildCapacity(i, capacity),
            onSelectSector: (sectorId) => _ctx.onChildSelectSector(i, sectorId),
            onUnselectSector: (sectorId) => _ctx.onChildUnselectSector(i, sectorId),
            onToggleActive: ($event: any) => (_ctx.onChildToggleActive(i)),
            onDeleteSlot: ($event: any) => (_ctx.onDeleteChildTimeSlot(i))
          }, null, 8, ["index", "is-active", "time-from", "time-to", "capacities", "sectors-loading", "sectors-failed", "sectors", "sector-ids", "resource-limits", "main-time-range", "reserved-time-range", "onTimeFrom", "onTimeTo", "onUpdateCapacity", "onSelectSector", "onUnselectSector", "onToggleActive", "onDeleteSlot"]))
        }), 128))
      ]),
      (!_ctx.state.is_loading)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            type: "button",
            class: "medium second w-full mt-5",
            onClick: _ctx.onAddChildTimeSlot
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createTextVNode(" Добавить внутренний тайм-слот ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_the_button, {
        type: "button",
        class: "medium second",
        onClick: _ctx.onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("Отмена")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_the_button, {
        type: "button",
        class: "medium primary",
        loading: _ctx.state.is_loading,
        onClick: _ctx.onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode("Добавить")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}